export default __webpack_public_path__ + "static/twk-lausanne-light-ec95368820b541223c35c92828749fff.woff2";